import i18n from "@/plugins/vue-i18n";

const Articles = () =>
  import(/* webpackChunkName: "articles" */ "@/views/manager/articles/index/ArticleIndexPage.vue");
const ArticleAdd = () =>
  import(/* webpackChunkName: "articles" */ "@/views/manager/articles/add/ArticleAddPage.vue");
const ArticleEdit = () =>
  import(/* webpackChunkName: "articles" */ "@/views/manager/articles/edit/ArticleEditPage.vue");
const ArticlesCategories = () =>
  import(
    // eslint-disable-next-line max-len
    /* webpackChunkName: "articlesCategories" */ "@/views/manager/articles/categories/index/ArticleCategoryIndexPage.vue"
  );
const ArticlesCategoriesAdd = () =>
  import(
    /* webpackChunkName: "articlesCategories" */ "@/views/manager/articles/categories/add/ArticleCategoryAddPage.vue"
  );
const ArticlesCategoriesEdit = () =>
  import(
    /* webpackChunkName: "articlesCategories" */ "@/views/manager/articles/categories/edit/ArticleCategoryEditPage.vue"
  );

const articles = [
  {
    path: "articles",
    name: "Articles",
    component: Articles,
    meta: {
      title: i18n.t("title.articles"),
    },
  },
  {
    path: "articles/add",
    name: "ArticleAdd",
    component: ArticleAdd,
    meta: {
      title: i18n.t("title.articles"),
    },
  },
  {
    path: "articles/:id/edit",
    name: "ArticleEdit",
    component: ArticleEdit,
    meta: {
      title: i18n.t("title.articles"),
    },
  },
  {
    path: "articles/categories",
    name: "ArticlesCategories",
    component: ArticlesCategories,
    meta: {
      title: i18n.t("title.categories"),
    },
  },
  {
    path: "articles/categories/add",
    name: "ArticlesCategoriesAdd",
    component: ArticlesCategoriesAdd,
    meta: {
      title: i18n.t("title.categories"),
    },
  },
  {
    path: "articles/categories/:id/edit",
    name: "ArticlesCategoriesEdit",
    component: ArticlesCategoriesEdit,
    meta: {
      title: i18n.t("title.categories"),
    },
  },
];

export default articles;
